import {createActions} from 'reduxsauce';

export const {Types: ProductsTypes, Creators: ProductsActionCreators} = createActions ({
    productsStart: ['selectedItem', 'pageSize', 'filters', 'brandId'],
    productsSuccess: ['data', 'selectedMenuId', 'filters', "pageSize"],
    productsFailure: ['error'],
});